import React, { useEffect, useState } from 'react'
import { Button, CircularProgress, Container, TextField, Typography } from '@material-ui/core'
import { useSnackbar } from 'notistack'
import { get } from 'lodash'
import { useHistory } from 'react-router-dom'
import { useCookies } from 'react-cookie'

import loginStyles from './css/loginStyles'
import { ReactComponent as LogoRipley } from '../../assets/svg/logoRipley.svg'
import useFormHooks from '../../components/hooks/useFormHooks'
import { loginService } from '../../api/api'
import { useSession } from '../../contexts/SessionContext'

const Login = () => {
  const classes = loginStyles()
  const history = useHistory()
  const { enqueueSnackbar } = useSnackbar()
  const [, setCookie, removeCookie] = useCookies(['statusCookie'])
  const { setSessionData } = useSession()

  useEffect(() => {
    setSessionData({})
    removeCookie('statusCookie')
  }, [])

  const [isLoading, setIsLoading] = useState(false)

  const initialState = {
    username: '',
    password: '',
  }

  const { handleSubmit, handleInputChange, inputs, clearInputs } = useFormHooks(
    initialState,
    async () => {
      setIsLoading(true)
      try {
        const { status, userfullname, userAuthKey } = await loginService(
          get(inputs, 'username'),
          get(inputs, 'password')
        )

        setSessionData({ status, userfullname, userAuthKey })

        const today = new Date()
        const expires = new Date(today.getTime() + 2 * 60000)
        setCookie('userfullname', userfullname, { expires })
        setCookie('statusCookie', status, { expires })

        setIsLoading(false)
        clearInputs()
        return history.push('buscar')
      } catch (error) {
        enqueueSnackbar(
          get(error, 'response.data.error_description') || get(error, 'message') || '',
          {
            variant: 'error',
            autoHideDuration: 1000,
          }
        )
        setIsLoading(false)
        return error
      }
    }
  )

  return (
    <form className={classes.root} onSubmit={handleSubmit}>
      <Container maxWidth="xs" className={classes.container}>
        <LogoRipley />
        <Typography variant="h5" className={classes.title}>
          Ticket de regalo
        </Typography>
        <Typography className={classes.subTitle}>Ingresa con tu cuenta Ripley</Typography>

        <TextField
          required
          fullWidth
          label="Usuario"
          variant="outlined"
          name="username"
          value={get(inputs, 'username')}
          onChange={handleInputChange}
          className={classes.textField}
        />
        <TextField
          required
          fullWidth
          label="Contraseña"
          variant="outlined"
          name="password"
          value={get(inputs, 'password')}
          onChange={handleInputChange}
          type="password"
          className={classes.textField}
        />
        {isLoading ? (
          <CircularProgress />
        ) : (
          <Button
            fullWidth
            size="large"
            variant="contained"
            color="primary"
            type="submit"
            style={{ height: 56 }}
          >
            Iniciar sesión
          </Button>
        )}
      </Container>
    </form>
  )
}

export default Login
